import _ from 'lodash'
import {FULLFILL_AVAILABLE_CASE_TYPES} from '@/store/modules/cases/mutations/available'

export const afterApplicationInit = {
    root: true,
    async handler(namespacedContext, payload) {
        const availableCaseTypes = _.get(payload, 'availableCaseTypes', [])

        namespacedContext.commit(FULLFILL_AVAILABLE_CASE_TYPES, availableCaseTypes)
    }
}
